import * as APPURLS from './';

export type URLType = { [key: string]: string };

export const ROOT_URL = '/';
export const DASHBORD_ROOT_URL = `${ROOT_URL}dashboard/`;

export const URL_PREFIX = {
  ROOT_URL: `${ROOT_URL}`,

  AUTH: `${ROOT_URL}auth`,

  // Dashboard
  HOME_MODULE: `${DASHBORD_ROOT_URL}`,
  ADMIN: `${DASHBORD_ROOT_URL}admin`,
  CARD_MANAGEMENT_SYSTEM: `${DASHBORD_ROOT_URL}card-management-system`,
  TERMINAL_MANAGEMENT_SYSTEM: `${DASHBORD_ROOT_URL}terminal-management-system`,
  TRANSACTION: `${DASHBORD_ROOT_URL}transaction`,
  INTERFACE_MANAGEMENT: `${DASHBORD_ROOT_URL}interface-management`,
  USERS_MODULE: `${DASHBORD_ROOT_URL}users`,
  REPORTING_MODULE: `${DASHBORD_ROOT_URL}report`,
  BATCHES_PROCESSING: `${DASHBORD_ROOT_URL}batches-processing`, 
  FRAUD_MANAGEMENT: `${DASHBORD_ROOT_URL}fraud-management`,
};

// ALL APP ROUTES
const URLConfig = {
  ROOT: ROOT_URL,
  NOT_FOUND: '/not-found',

  // Admin Module
  ADMIN: {
    ...APPURLS.admin(URL_PREFIX.ADMIN),
  },

  // CARD MANAGEMENT SYSTEM Module
  CARD_MANAGEMENT_SYSTEM: {
    ...APPURLS.cardManagementSystem(URL_PREFIX.CARD_MANAGEMENT_SYSTEM),
  },

  // TERMINAL MANAGEMENT SYSTEM Module
  TERMINAL_MANAGEMENT_SYSTEM: {
    ...APPURLS.terminalManagementSystem(URL_PREFIX.TERMINAL_MANAGEMENT_SYSTEM),
  },
  
  // TRANSACTION Module
  TRANSACTION: {
    ...APPURLS.transaction(URL_PREFIX.TRANSACTION),
  },

  // FRAUD MANAGEMENT Module
  FRAUD_MANAGEMENT: {
    ...APPURLS.fraudManagement(URL_PREFIX.FRAUD_MANAGEMENT),
  },

  // BATCHES PROCESSING Module
  BATCHES_PROCESSING: {
    ...APPURLS.batchesProcessing(URL_PREFIX.BATCHES_PROCESSING),
  },
  
  // INTERFACE Module
  INTERFACE_MANAGEMENT: {
    ...APPURLS.interfaceManagement(URL_PREFIX.INTERFACE_MANAGEMENT),
  },

  // Auth Module
  AUTH: {
    ...APPURLS.auth(URL_PREFIX.AUTH),
  },

  // Home
  HOME: {
    ...APPURLS.home(URL_PREFIX.HOME_MODULE),
  },

  USERS: {
    ...APPURLS.users(URL_PREFIX.USERS_MODULE),
  },

  // Reporting Module
  REPORTING: {
    ...APPURLS.reporting(URL_PREFIX.REPORTING_MODULE)
  }
};

console.log(URLConfig);

export default URLConfig;
